import { Notification } from 'element-ui';
import axios from '../../axios';

import cfg from '../../config/config';

window.Notification = Notification;

export default {
  namespaced: true,
  state: {
    appMode: 'SPA',
    host: '',
    daterange: {},
    clearDaterange: false,
    people: '',
    bedrooms: '',
    keepalive: '',
    overlay: false,
    shortlist: [],
    currentSection: '',
    currentRedirectSection: '',
    currentMobileSection: '',
    screenType: '',
    searchWidth: 0,
    shortlistWidth: 0,
    tooltip: '',
    searchResults: [],
    quicklinks: false,
    api: '',
    office: {},
    cookieNotice: true,
    cookieStay: true,
    cookieNewDestinationViewed: 0,
    token: '',
    user: {},
    searchwide: false,
    navfixed: false,
    screenSize: {},
    fakeFullScreen: false,
    isSlideshowFullScreen: false,
    fullNavHeight: 0,
    language: 'en',
    currentScrollTop: 0,
    scaPageID: 0,
    datepickerOpen: false,
    apiDataLoaded: false,
  },
  getters: {
    getCurrentScrollTop(state) {
      return state.currentScrollTop;
    },
    getSCAPageID(state) {
      return state.scaPageID;
    },
    currentLanguage(state) {
      return state.language;
    },
    getSlideshowFullScreen(state) {
      return state.isSlideshowFullScreen;
    },
    getFakeFullScreen(state) {
      return state.fakeFullScreen;
    },
    getHost(state) {
      return state.host;
    },
    getDaterange(state) {
      return state.daterange;
    },
    getPeople(state) {
      return state.people;
    },
    getBedrooms(state) {
      return state.bedrooms;
    },
    getClearDaterange(state) {
      return state.clearDaterange;
    },
    getOverlay(state) {
      return state.overlay;
    },
    getShortlist(state) {
      return state.shortlist;
    },
    getCurrentSection(state) {
      return state.currentSection;
    },
    getCurrentRedirectSection(state) {
      return state.currentRedirectSection;
    },
    getScreenType(state) {
      return state.screenType;
    },
    getSearchWidth(state) {
      return state.searchWidth;
    },
    getShortlistWidth(state) {
      return state.shortlistWidth;
    },
    getCurrentMobileSection(state) {
      return state.currentMobileSection;
    },
    getVideo(state) {
      return state.video;
    },
    getTooltip(state) {
      return state.tooltip;
    },
    getSearchResults(state) {
      return state.searchResults;
    },
    getQuicklinks(state) {
      return state.quicklinks;
    },
    getOfficeStatus(state) {
      return state.office;
    },
    getCookieNotice(state) {
      return state.cookieNotice;
    },
    getCookieStay(state) {
      return state.cookieStay;
    },
    getCookieNewDestinationViewed(state) {
      return state.cookieNewDestinationViewed;
    },
    getToken(state) {
      return state.token;
    },
    getUser(state) {
      return state.user;
    },
    getSearchwide(state) {
      return state.searchwide;
    },
    getApi(state) {
      return state.api;
    },
    getNavfixed(state) {
      return state.navfixed;
    },
    getScreenSize(state) {
      return state.screenSize;
    },
    getFullNavHeight(state) {
      return state.fullNavHeight;
    },
    getApiDataLoaded(state) {
      return state.apiDataLoaded;
    },
  },
  mutations: {
    setCurrentScrollTop(state, payload) {
      state.currentScrollTop = payload;
    },
    setSCAPageID(state, payload) {
      state.scaPageID = payload;
    },
    setCurrentLanguage(state, payload) {
      state.language = payload;
    },
    setSlideshowFullScreen(state, payload) {
      state.isSlideshowFullScreen = payload;
    },
    setFakeFullScreen(state, payload) {
      state.fakeFullScreen = payload;
    },
    setHost(state, host) {
      state.host = host;
    },
    updateDaterange(state, payload) {
      state.daterange = payload;
    },
    clearDaterange(state, payload) {
      state.daterange = payload;
    },
    updatePeople(state, payload) {
      state.people = payload;
    },
    updateBedrooms(state, payload) {
      state.bedrooms = payload;
    },
    updateKeepalive(state, payload) {
      state.keepalive = payload;
    },
    updateClearDaterange(state, payload) {
      state.clearDaterange = payload;
    },
    showOverlay(state, payload) {
      state.overlay = payload;
    },
    hideOverlay(state, payload) {
      state.overlay = payload;
    },
    updateShortlist(state, payload) {
      state.shortlist = payload;
    },
    addShortlist(state, card) {
      state.shortlist.unshift(card);
    },
    openSection(state, section) {
      state.currentSection = section;
    },
    closeSection(state, close) {
      state.currentSection = close;
    },
    setCurrentRedirectSection(state, section) {
      state.currentRedirectSection = section;
    },
    setScreenType(state, type) {
      state.screenType = type;
    },
    setSearchWidth(state, width) {
      state.searchWidth = width;
    },
    setShortlistWidth(state, width) {
      state.shortlistWidth = width;
    },
    openMobileSection(state, section) {
      state.currentMobileSection = section;
    },
    closeMobileSection(state, section) {
      state.currentMobileSection = section;
    },
    openVideo(state, open) {
      state.video = open;
    },
    closeVideo(state, close) {
      state.video = close;
    },
    updateTooltip(state, text) {
      state.tooltip = text;
    },
    resetSearchResults(state, reset) {
      state.searchResults = reset;
    },
    showQuicklinks(state, show) {
      state.quicklinks = show;
    },
    hideQuicklinks(state, hide) {
      state.quicklinks = hide;
    },
    updateOfficeStatus(state, officeStatus) {
      state.office = officeStatus;
    },
    closeCookieNotice(state, closeCookieNotice) {
      state.cookieNotice = closeCookieNotice;
    },
    setStayCookie(state, setStayCookie) {
      state.cookieStay = setStayCookie;
    },
    setCookieNewDestinationViewed(state, value) {
      state.cookieNewDestinationViewed = value;
    },
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setSearchwide(state, iswide) {
      state.searchwide = iswide;
    },
    setNavfixed(state, fixed) {
      state.navfixed = fixed;
    },
    setScreenSize(state, obj) {
      state.screenSize = obj;
    },
    setFullNavHeight(state, payload) {
      state.fullNavHeight = payload;
    },
    setApiDataLoaded(state, payload) {
      state.apiDataLoaded = payload;
    },
  },
  actions: {
    addShortlist(context, card) {
      if (typeof card === 'object') {
        const isCardAdded = context.state.shortlist.find((item) => item.id === card.id);
        if (!isCardAdded) {
          context.commit('addShortlist', card);
          context.dispatch('showNotification', {
            villaName: card.name,
            actionName: 'added to shortlist',
            position: 'bottom-right',
            type: 'success',
          });

          const idProperty = [];
          for (let x = 0; x < context.state.shortlist.length; x++) {
            idProperty.unshift(context.state.shortlist[x].id);
          }
          // Google Tag Manager - do datalayer push (id of the villa added from shortlist)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            id_property: `${card.id}`,
            action: 'add',
            ids_properties: JSON.stringify(idProperty),
          });

          // Algolia Conversion
          context.dispatch('algolia/checkForConversionEvent', 'add_to_shortlist', { root: true });
        }
        // console.log('context.state', context.state.shortlist)
        const currentShortlistIds = context.state.shortlist.map((i) => i.id);
        window.$cookies.set(
          'currentshortlist',
          JSON.stringify(currentShortlistIds),
          new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        );
      }
    },
    removeShortlist(context, card) {
      const updatedShortlist = context.state.shortlist.filter((item) => item.id !== card.id);

      context.commit('updateShortlist', updatedShortlist);
      context.dispatch('showNotification', {
        villaName: card.name, actionName: 'removed from shortlist', position: 'bottom-right', type: 'info',
      });

      const idProperty = [];
      for (let x = 0; x < updatedShortlist.length; x++) {
        idProperty.unshift(updatedShortlist[x].id);
      }

      // Google Tag Manager - do datalayer push (id of the villa removed from shortlist)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        id_property: `${card.id}`,
        action: 'remove',
        ids_properties: JSON.stringify(idProperty),
      });

      const currentShortlistIds = context.state.shortlist.map((i) => i.id);
      window.$cookies.set(
        'currentshortlist',
        JSON.stringify(currentShortlistIds),
        new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      );
    },
    clearShortlist(context) {
      const slist = [];
      context.commit('updateShortlist', slist);
      window.$cookies.set('currentshortlist', slist, new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
      Notification.success({
        customClass: 'custom-notification',
        iconClass: 'custom-success-icon',
        title: 'Shortlist cleared.',
        position: 'bottom-right',
        duration: 1700,
      });
    },
    closeVideo(context, close) {
      context.commit('closeVideo', close);
      context.commit('hideOverlay', false);
      context.commit('closeSection', '');
    },
    getOfficeHours({ commit }, data) {
      axios
        .get('/core/officehours', {
          params: {
            timezone: data.timezone,
            lang: 'en',
          },
        })
        .then((rs) => {
          commit('updateOfficeStatus', rs.data);
        });
    },
    setSearchWidth(context, width) {
      document.documentElement.style.setProperty('--menu-width-plus', width);
      document.documentElement.style.setProperty(
        '--menu-width-minus',
        `-${width}`,
      );
      context.commit('setSearchWidth', width);
    },

    showNotification(context, payload) {
      if (payload.type === 'info') {
        Notification.info({
          customClass: 'custom-notification',
          iconClass: 'custom-info-icon',
          title: `${payload.villaName} ${payload.actionName}`,
          // message: `Villa ${rs.data.name} from ${rs.data.dest} has been removed from your shortlist.`,
          // showClose: true,
          position: payload.position,
          duration: 1700,
        });
      } else if (payload.type === 'success') {
        Notification.success({
          customClass: 'custom-notification',
          iconClass: 'custom-success-icon',
          title: `${payload.villaName} ${payload.actionName}`,
          // message: `Villa ${rs.data.name} from ${rs.data.dest} has been removed from your shortlist.`,
          position: payload.position,
          duration: 1700,
        });
      }
    },
  },
};
